module.exports = __webpack_public_path__ + "img/39.0b344b34.jpg";